import React from 'react';
import isNil from 'lodash/isNil';
import AlertTitle from '@mui/material/AlertTitle';
import clsx from 'clsx';
import {
  Props,
} from 'pages/Dashboard/pages/Charts/pages/Details/types/tabContentProps';
import PatientGeneralInfo from 'pages/Dashboard/pages/Charts/pages/Details/components/Demographics/GeneralInfo';
import PatientContactInfo from 'pages/Dashboard/pages/Charts/pages/Details/components/Demographics/ContactInfo';
import PatientAddressInfo from 'pages/Dashboard/pages/Charts/pages/Details/components/Demographics/AddressInfo';
import PatientOccupationInfo from 'pages/Dashboard/pages/Charts/pages/Details/components/Demographics/OccupationInfo';
import PatientPCPInfo from 'pages/Dashboard/pages/Charts/pages/Details/components/Demographics/PCPInfo';
import Alert from 'pages/Dashboard/components/Alert';
import Accordion from 'core/components/Accordion';
import OtherContactFields from 'pages/Dashboard/pages/Appointments/pages/List/components/CreatePatientDialog/OtherContactFields';
import PatientAlerts from 'views/EMR/PatientAlerts';

const rootClassName = 'px-4 !m-0 flex w-full items-center justify-between';

export default function Demographics({ patient }: Props) {
  return (
    <>
      <Alert
        severity="error"
        open={!isNil(patient.dosespotError)}
        className="mb-4"
        icon={false}
      >
        <AlertTitle className={rootClassName}>
          {patient?.dosespotError?.title ?? ''}
        </AlertTitle>
        <p className={clsx('!mt-2', rootClassName)}>
          {patient.dosespotError?.details ?? ''}
        </p>
      </Alert>
      <div className="flex flex-col gap-form-row w-full populate-form">
        <PatientAlerts patientId={patient.patientId ?? 0} />
        <PatientGeneralInfo />
        <PatientContactInfo />
        <PatientAddressInfo />
        <PatientPCPInfo />
        <PatientOccupationInfo />
        <Accordion
          defaultExpanded
          header="Other Contact"
          disableGutters
          headerClasses={{
            root: '!px-2 !py-1 !min-h-[initial] !bg-gray-100 !text-gray-600 !font-semibold text-sm',
            content: '!m-0',
          }}
          detailsClasses={{ root: '!p-2 populate-form gap-form-row flex flex-col w-full' }}
        >
          <OtherContactFields />
        </Accordion>
      </div>
    </>
  );
}
